import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flex _ai-c" }
const _hoisted_2 = { class: "_flexcol" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkbox_field = _resolveComponent("checkbox-field")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['_mt-3 _ba-2 _rounded--common', {'_bc--input': !$data.isSelected}, {'_bc--primary': $data.isSelected}]),
    "data-qa": "payment-type:Money"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['_cur-p _pa-3']),
      onClick: _cache[1] || (_cache[1] = $event => ($options.onSelectPaymentType()))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_checkbox_field, {
          modelValue: $data.isSelected,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.isSelected) = $event)),
          "show-label": false,
          name: "paymentTypeItem",
          class: "_mt-0 _mr-2",
          type: "radio"
        }, null, 8 /* PROPS */, ["modelValue"]),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Resources.Checkout.CheckoutPaymentTypeMoneyLabel), 1 /* TEXT */)
      ])
    ])
  ], 2 /* CLASS */))
}